import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../app/hooks";
import { useParams } from "react-router";
import { schoolSlice, selectSchool } from "../../../redux/school/schoolSlice";
import PageAuthenticatedLoading from "../../../features/pages/PageAuthenticatedLoading";
import { imageInsSlice } from "../../../redux/image/imageInsSlice";
import { ElementUploadImage } from "../../../features/base/image/ElementUploadImage";
import ElementSkeleton from "../../../features/base/ElementSkeleton";
import RoutinePageTitle from "../basics/RoutinePageTitle";
import RoutinePageAvatar from "../basics/RoutinePageAvatar";
import { routineSlice, selectRoutine } from "../../../redux/routine/routineSlice";
import { routeRoutine } from "../../../routes/routine";
import { ElementMissingContext } from "../../../features/base/ElementMissingContext";
import { ObjectTarget } from "../../../app/permissions";
import { assertThumbnailUrl } from "../../../redux/common";
import { TopBar } from "../../../features/top/TopBar";

export function RoutineImage() {
    const school = useSelector(selectSchool);
    const routine = useSelector(selectRoutine);
    const dispatch = useAppDispatch();

    const {schoolId, routineId} = useParams();
    console.debug(`SchoolImage: ${schoolId}, Routine: ${routineId}`);
    if(!schoolId || !routineId) {
        return <ElementMissingContext />;
    }

    const breadcrumbTitle = "Alterar Imagem";
  
    const breadcrumbs = [ { label: breadcrumbTitle }, ];

    const title = <RoutinePageTitle schoolId={schoolId} routineId={routineId} />;
    const pageAvatar = <RoutinePageAvatar />;
  
    const buildContent = () =>
        (routine.selected)
        ? <ElementUploadImage 
              currentImage={assertThumbnailUrl(routine.selected.url)}
              name={routine.selected.name}
              backTo={routeRoutine(schoolId, routineId)}
              target={{schoolId: schoolId, avatar: true, objectTarget: ObjectTarget.ROUTINE, targetId: routineId}}
              backCleanup={() => {
                dispatch(schoolSlice.actions.clean());
                dispatch(routineSlice.actions.clean());
                dispatch(imageInsSlice.actions.clean());
              }}
          />
        : <ElementSkeleton />
      ;

    return <PageAuthenticatedLoading key="routineImage"
        topbar={ <TopBar title={title} pageAvatar={pageAvatar} breadcrumbs={breadcrumbs} /> }
        loading={{
            states: [school.state, routine.state], 
            content: buildContent,
            error: "Erro ao carregar departamento",
            retry: () => {
            dispatch(schoolSlice.actions.clean());
            },
        }}
    />;
                
}
